// Keep all configurable values in this file!
// @ts-nocheck

export const localStoragePrefix = "guude-ai:";

export const apiUrl = ENVJS_API_URL ?? "http://localhost:8080";
export const appUrl = ENVJS_APP_URL ?? "http://localhost:5173";

export const version = ENVJS_APP_VERSION ?? "dev";
export const applicationVersion = ENVJS_APP_VERSION ?? "dev";
export const applicationVersionTime =
    ENVJS_APP_VERSION_TIMESTAMP ??
    new Date().toLocaleString("de-DE", { timeZone: "Europe/Berlin" });

export const stimmen = ENVJS_STIMMEN ?? {};

export const oidcClientId =
  import.meta.env.VITE_OIDC_CLIENT_ID ?? "guude-ai-app";

export const drawerWidth = 340;

export const PUBLIC_ROUTES: string[] = ["/testanruf"];

export const inboundApiUrl = ENVJS_INBOUND_API_URL ?? "https://YOUR_NGROK_URL/api/v1/test-call";

export const telefonnummer = ENVJS_INBOUND_PHONE_NUMBER ?? "+49 6051 4924010";

export const DEFAULT_EMPATHY = ENVJS_DEFAULT_EMPATHY ?? 0.8;